import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import {Subject, Subscription} from 'rxjs';
import {debounceTime, throttleTime} from 'rxjs/operators';

@Directive({
  selector: '[appDebounceClick]',
  standalone: false
})
export class Prevent2xClickDirective implements OnInit, OnDestroy {

  @Input()
  debounceTime = 600;

  @Output()
  debounceClick = new EventEmitter();

  private clicks = new Subject();
  private subscription: Subscription;

  constructor() {
  }

  @HostListener('click', ['$event'])
  clickEvent(event) {
    event.preventDefault();
    // event.stopPropagation();
    this.clicks.next(event);
  }

  ngOnInit() {
    // this.subscription = this.clicks.pipe(
       // debounceTime(this.debounceTime)
    this.subscription = this.clicks.pipe(throttleTime(this.debounceTime)).subscribe(e => this.debounceClick.emit(e));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}

